import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {DisposeBag} from "../modules/DisposeBag";
import {LeadSourceDto} from "../model/LeadSourceDto";
import {EntityBaseDto} from "../model/EntityBaseDto";
import {ConfigService} from "../modules/ConfigModule";

class RecordAuditWidgetController implements IComponentController {
    model: EntityBaseDto;

    constructor(private $config: ConfigService) {
    }


    $onInit(): void {
    }

    $onDestroy() {
    }
}

export default angular.module('component.recordAuditWidget', [])
    .component('recordAuditWidget', {
        template: require('./RecordAuditWidget.html'),
        controller: RecordAuditWidgetController,
        bindings: {
            model: '=',
        }
    }).name;
